// 答卷状态
export const answer_status_options = [
  { key: '3', value: '正在答题' },
  { key: '0', value: '待质控' },
  { key: '1', value: '质控通过' },
  { key: '2', value: '质控拒绝' },
  { key: '4', value: '被甄别' },
  { key: '5', value: '超时' },
  { key: '6', value: '超额' },
  { key: '10', value: '质控驳回' },
  { key: '11', value: '已终止' },
  { key: '12', value: '处理中' },
  { key: '13', value: '自动作废' },
  { key: '15', value: '被甄别' }
  /*   { key: '8', value: '待审核' },
  { key: '9', value: '审核拒绝' } */
]
// 2021-1-27 委托代理的答卷状态 同答卷状态，但文字不同
export const answer_status_options__proxy = [
  { key: '0', value: '等待二审' },
  { key: '1', value: '质控通过' }, // 原型如此
  { key: '2', value: '二审拒绝' },
  { key: '8', value: '等待一审' },
  { key: '9', value: '一审拒绝' },
  //
  { key: '3', value: '正在答题' },
  { key: '4', value: '被甄别' },
  { key: '5', value: '超时' },
  { key: '6', value: '超额' },
  { key: '10', value: '质控驳回' },
  { key: '11', value: '已终止' },
  { key: '12', value: '处理中' },
  { key: '13', value: '自动作废' },
  { key: '15', value: '被甄别' }
]
// 2021-1-28  、全部用答卷状态
export const answer_status_options__all = [
  { key: '3', value: '正在答题' },
  { key: '0', value: '待质控（或等待二审）' },
  { key: '1', value: '质控通过' },
  { key: '2', value: '质控拒绝（或二审拒绝）' },
  { key: '4', value: '被甄别' },
  { key: '5', value: '超时' },
  { key: '6', value: '超额' },
  { key: '10', value: '质控驳回' },
  { key: '11', value: '已终止' },
  { key: '8', value: '等待一审' },
  { key: '9', value: '一审拒绝' },
  { key: '12', value: '处理中' },
  { key: '13', value: '自动作废' },
  { key: '15', value: '被甄别' }
]
// 回收渠道
// 20201022 网络调查 改为 链接&二维码
export const channel_list_options = {
  [0]: '链接&二维码',
  [1]: '督导吧任务',
  [2]: '面对面访问',
  [5]: '短信发送',
  [7]: '电话访问',
  [8]: '由系统导入',
  [9]: '委托代理',
  [10]: '样本库推送',
  [12]: '样本服务',
  [17]: '定向发布（企业员工）',
  [18]: '定向发布（外部组织）'
}
// 答卷状态 0=待质控,1=质控通过,2=质控拒绝,3=正在答题,4=被甄别,5=超时,6=超额,7=测试,8=待审核,9=审核拒绝
// 以及对应tag 状态
export const typeConfig = {
  [0]: { label: '待质控', tagType: 'warning' },
  [1]: { label: '质控通过', tagType: 'success' },
  [2]: { label: '质控拒绝', tagType: 'danger' },
  [3]: { label: '正在答题', tagType: 'info' },
  [4]: { label: '被甄别', tagType: 'info' },
  [5]: { label: '超时', tagType: 'warning' },
  [6]: { label: '超额', tagType: 'danger' },
  [7]: { label: '测试', tagType: 'info' },
  [8]: { label: '待审核', tagType: 'warning' },
  [9]: { label: '审核拒绝', tagType: 'danger' },
  [10]: { label: '质控驳回', tagType: 'warning' },
  [11]: { label: '已终止', tagType: 'danger' },
  [12]: { label: '处理中', tagType: 'warning' },
  [13]: { label: '自动作废', tagType: 'info' },
  [15]: { label: '被甄别', tagType: 'info' }
}
// 2021-1-27 委托代理的答卷状态 配套的tag显示
export const typeConfig__proxy = {
  [0]: { label: '等待二审', tagType: 'warning' },
  [1]: { label: '质控通过', tagType: 'success' },
  [2]: { label: '二审拒绝', tagType: 'info' },
  [8]: { label: '等待一审', tagType: 'warning' },
  [9]: { label: '一审拒绝', tagType: 'info' },
  [10]: { label: '驳回', tagType: 'danger' },
  // 其他补全
  [3]: { label: '正在答题', tagType: 'info' },
  [4]: { label: '被甄别', tagType: 'info' },
  [5]: { label: '超时', tagType: 'warning' },
  [6]: { label: '超额', tagType: 'danger' },
  [7]: { label: '测试', tagType: 'info' },
  [11]: { label: '已终止', tagType: 'danger' },
  [12]: { label: '处理中', tagType: 'warning' },
  [13]: { label: '自动作废', tagType: 'info' },
  [15]: { label: '被甄别', tagType: 'info' }
}
// 质控方式
export const answer_qcType_options = [
  { key: '0', value: '其他' },
  { key: '1', value: '自动过审' },
  { key: '2', value: '人工审核' },
  { key: '3', value: '批量审核' },
  { key: '4', value: '质控题' }
]
export function getQcTypeValue(key) {
  const res = answer_qcType_options.find(item => {
    return key + '' === item.key
  })
  return (res && res.value) || ''
}
